import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const AgRequests = React.lazy(() => import('./index'));
const AgRequestTable = React.lazy(() => import('./agRequestTable'));
const AgRequest = React.lazy(() => import('./agRequest'));
const AgRequestDetail = React.lazy(() => import('./agRequestDetail'));
const AddNewAgRequest = React.lazy(() => import('./addNewAgRequest'));
const EditAgRequest = React.lazy(() => import('./editAgRequest'));

export const useAgRequestRoutes = () => {

    return (
        <Route path="agRequests" element={<Suspense fallback={<div>منتظر باشید...</div>}><AgRequests /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><AgRequestTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewAgRequest/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><AgRequest/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><AgRequestDetail/></Suspense> } />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditAgRequest/></Suspense> } />
            </Route>
        </Route>
    )
}